export default __webpack_public_path__ + "static/media/Reader's Tunic of the Forbidden Art.efe955b0.jpg";